import { render, staticRenderFns } from "./Places.vue?vue&type=template&id=344d0368&"
import script from "./Places.vue?vue&type=script&lang=ts&"
export * from "./Places.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports